// noinspection AllyPlainJsInspection

import api from "./api";
import store from "../store/index";

export async function getOpenProducts({search} = {search: null}) {
  const result = await api.get(
    `/api/v1/product/open/${store.state.customerID}`,
    {
      params: {
        search,
      },
    },
  );

  return result.data;
}

export async function getProducts({search}) {
  const result = await api.get(
    `/api/v1/product/all/${store.state.customerID}`,
    {
      params: {
        search,
      },
    },
  );

  return result.data;
}

export async function getProduct(serialID) {
  const url = new URL(window.location.href);
  const headers = {};

  if (url.searchParams.get("AudicienID")) {
    headers.Authorization = `Bearer ${url.searchParams.get("AudicienID")}`;
  }

  const requestData = await api.get("/api/v1/item", {
    params: {
      serialID: serialID,
      customerID: store.state.customerID,
    },
    headers,
  });

  return requestData.data;
}

export async function getOptions() {
  const url = new URL(window.location.href);
  const headers = {};

  if (url.searchParams.get("AudicienID")) {
    headers.Authorization = `Bearer ${url.searchParams.get("AudicienID")}`;
  }
  const requestData = await api.get("/api/v1/item/options", {headers});

  return requestData.data;
}
